import { Divider, Heading } from './comps'


export function Section({ mode, title, size = 'h2', children }) {
    
    let titlecomp = null;
    if (title) titlecomp = <Heading size={size}>{title}</Heading>
    
    return (
        <>
            {titlecomp}
            {title ? <Divider mode={mode} /> : null}
            {children}
        </>
    );
}